import { TestamentaryEntityKind } from '@/types/schema';

import {
  entityGstStatusToApiTypeMap,
  estateInclusionStatusToApiTypeMap,
} from '../../EntitySubforms/utils/shared/taxStatus.utils';
import { DefaultEstateTaxStatus } from '../shared/testamentaryEntity.types';
import { getTEAssetLocationDefaults } from '../shared/testamentaryEntity.utils';
import {
  CREATE_TESTAMENTARY_ENTITY_SHORT_FORM,
  CreateTestamentaryEntityShortFormShape,
} from './CreateTestamentaryEntityModal.types';

interface GetDefaultValuesParams {
  areAllClientsDead: boolean;
  defaultEstateTaxStatus?: DefaultEstateTaxStatus;
  defaultName?: string;
  defaultKind?: TestamentaryEntityKind;
}

export function getDefaultValues({
  areAllClientsDead,
  defaultEstateTaxStatus,
  defaultName,
  defaultKind,
}: GetDefaultValuesParams): CreateTestamentaryEntityShortFormShape {
  const { estateInclusionStatus, survivingSpouseStateInEstateStatus } =
    getTEAssetLocationDefaults(defaultKind, areAllClientsDead);

  return {
    [CREATE_TESTAMENTARY_ENTITY_SHORT_FORM]: {
      displayName: defaultName ?? '',
      testamentaryEntityKind: defaultKind ?? '',
      createdFromEntityIds: [],
      gstStatus: defaultEstateTaxStatus?.gstStatus ?? '',
      estateInclusionStatus:
        defaultEstateTaxStatus?.estateInclusionStatus ?? estateInclusionStatus,
      survivingSpouseStateInEstateStatus:
        defaultEstateTaxStatus?.survivingSpouseStateInEstateStatus ??
        survivingSpouseStateInEstateStatus,
      accountOwnerId: '',
    },
  };
}

export function mapFormDataToMutationInput(
  formData: CreateTestamentaryEntityShortFormShape,
  householdId: string
) {
  const form = formData[CREATE_TESTAMENTARY_ENTITY_SHORT_FORM];

  if (!form.displayName || !form.testamentaryEntityKind) {
    throw new Error('Missing required fields for testamentary entity');
  }

  return {
    create: {
      displayName: form.displayName,
      kind: form.testamentaryEntityKind,
      householdID: householdId,
      createdFromEntityIDs:
        form.createdFromEntityIds.length > 0
          ? form.createdFromEntityIds
          : undefined,
      gstStatus: form.gstStatus
        ? entityGstStatusToApiTypeMap[form.gstStatus]
        : undefined,
      inEstateStatus: form.estateInclusionStatus
        ? estateInclusionStatusToApiTypeMap[form.estateInclusionStatus]
        : undefined,
      survivingSpouseStateInEstateStatus:
        form.survivingSpouseStateInEstateStatus
          ? estateInclusionStatusToApiTypeMap[
              form.survivingSpouseStateInEstateStatus
            ]
          : undefined,
      accountOwnerID: form.accountOwnerId || undefined,
    },
    withTrustees: [],
    withSuccessorTrustees: [],
    withTrustAdvisors: [],
    withDispositiveProvisions: [],
    withBeneficiaries: [],
  };
}
